/**
 * Register the membership reducer with Volto.
 *
 * Volto merges every add-on's reducers into a single store, so the slice
 * needs a unique key to avoid collisions.
 * @module config/reducers
 */

import type { ConfigType } from '@plone/registry';
import { membership } from '../reducers/membership';

/**
 * Install the membership reducer into the Volto configuration.
 *
 * @param config The Volto configuration registry.
 * @returns The registry, for chaining.
 */
export default function installReducers(config: ConfigType) {
  config.addonReducers = {
    ...(config.addonReducers || {}),
    membership,
  };

  return config;
}
